import { Video } from 'lucide-react'
import { MediaConvertPanel } from '@/features/media/media-convert-panel'
import { convertVideo, type VideoFormat } from '@cloudtools/wasm'
import { replaceExtension } from '@/lib/format'

const VIDEO_FORMATS: readonly { value: VideoFormat; label: string }[] = [
  { value: 'mp4', label: 'MP4 (H.264 + AAC)' },
  { value: 'webm', label: 'WebM (VP9 + Opus)' },
]

/** Video conversion flow wired to the FFmpeg.wasm worker. */
export function VideoPanel() {
  return (
    <MediaConvertPanel
      accept={['.mp4', '.mov', '.mkv', '.webm']}
      maxSizeMB={400}
      icon={Video}
      formats={VIDEO_FORMATS}
      defaultFormat="mp4"
      convert={(file, format, callbacks) => convertVideo({ input: file, ...callbacks }, format)}
      makeOutputName={(name, format) => replaceExtension(name, format)}
    />
  )
}
